module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/google-play-store-fr-d60ff9f626eb1e17a33f4946eee0922c.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/google-play-store-fr.svg
// module id = t6Bw
// module chunks = 24